// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_on-0";